import { render, staticRenderFns } from "./EditList.vue?vue&type=template&id=0513dfa6"
import script from "./EditList.js?vue&type=script&lang=js&external"
export * from "./EditList.js?vue&type=script&lang=js&external"
import style0 from "./EditList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports